import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {message} from "antd";
import {AUTH_TOKEN} from "../../../constants/AuthConstant";
import pengawasService from "../../../services/pengaturan/pengawasService";
import Cookies from "js-cookie";
import pegawaiService from "../../../services/pegawaiService";

export const initialState = {
    loading_pengawas: false,
    data_pengawas: [],
    data_import: [],
    showMessage:false,
    message:'',
}


export const getDataPengawas = createAsyncThunk('pengawas/data',async (data, { rejectWithValue }) => {
    try {
        const response = await pengawasService.data(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const getaDataImport = createAsyncThunk('pengawas/dataimport',async (data, { rejectWithValue }) => {
    try {
        const response = await pengawasService.data_import(localStorage.getItem(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})

export const getPenggunaPengawas = createAsyncThunk('pengawas/datapengguna',async (data, { rejectWithValue }) => {
    try {
        const response = await pengawasService.pengguna_pengawas(localStorage.getItem(AUTH_TOKEN),data)
        return response
    } catch (err) {}
})

export const emptyDataImport = createAsyncThunk('pengawas/emptyimport',async (data, { rejectWithValue }) => {
    try {
        const response = await pengawasService.empty_import(localStorage.getItem(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})

export const saveDataImport = createAsyncThunk('pengawas/saveimport',async (data, { rejectWithValue }) => {
    try {
        const response = await pengawasService.save_import(localStorage.getItem(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})

export const pengawasSlice = createSlice({
    name: 'pengawas',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading_pengawas = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataPengawas.fulfilled, (state, action) => {
                state.loading_pengawas = false
                state.data_pengawas = action.payload??[]
            })
            .addCase(getDataPengawas.pending, (state) => {
                state.loading_pengawas = true
            })
            .addCase(getDataPengawas.rejected, (state, action) => {
                state.loading_pengawas = false
                state.data_pengawas = action.payload
            })
            .addCase(getaDataImport.fulfilled, (state, action) => {
                state.loading_pengawas = false
                state.data_import = action.payload??[]
            })
            .addCase(getaDataImport.pending, (state) => {
                state.loading_pengawas = true
            })
            .addCase(getaDataImport.rejected, (state, action) => {
                state.loading_pengawas = false
                state.data_import = action.payload
            })
    },
})

export const {
    showLoading,
} = pengawasSlice.actions

export default pengawasSlice.reducer
